import * as React from 'react';
import { History } from 'history';
import {AppBar as AppBarMui, Badge, Grid, Toolbar} from '@mui/material';
import { Logo, Text, Transition } from '.';
import AppService, { textsize } from '../services/app.service';

interface Props {
  history?: History;
  color?: any;
  logo?: React.ReactNode;
  logoCaption?: string;
  avatar?:{
    name?: string,
    imageUrl?: string,
    onClick?: () => void,
  }
  menu?: {
    caption: string, 
    size?: textsize,
    bold?: boolean,
    icon?: string,
    iconSize?: textsize,
    badge?: number,
    useBackground?: boolean,
    section?: string,
    url?: string,
    historyState?: any,
    readOnly?: boolean,
  }[];
  menuColor?: any;
  width?: number;
  onClick?: () => void;
  onScrollEnd?: () => void;
  onHide?: (data: any) => void;
  children: React.ReactNode;
}


export const AppBar: React.FunctionComponent<Props> = (props) => {
  const [isMobile, setIsMobile] = React.useState(AppService.isMobile());
  const [isOnTop, setIsOnTop] = React.useState(true);
  const [width, setWidth] = React.useState(document.body.clientWidth);
  const isWebSignin = !isMobile && props.avatar?.name;
  const menuColor = props.menuColor || 'text.primary';

  const logo = () => {
    return (
      <Grid sx={{flexGrow: (props.menu || props.avatar) && 1}}> {props.logo || <Logo history={props.history} label={props.logoCaption}/>} </Grid>
    )
  }

  const menu = () => {
    if (props.menu)
    return (
      <>
      {props.menu?.map((d, i) => {
        return (
          <Badge key={i} color='warning' badgeContent={d.badge && <Text label={d.badge?.toString()} color='background.default' size='small' />} anchorOrigin={{vertical: 'top', horizontal: 'left'}} >
            <Text label={d.caption} size={d.size} lineHeight={1} color={menuColor} bgColor={!isMobile && d.useBackground && props.color} textAlign='center' bold={d.bold} icon={d.icon} iconSize={d.iconSize} iconOnTop={isMobile} sx={{border: !isMobile && d.useBackground && !isOnTop && 1, borderRadius: 20, padding: 0.5, paddingLeft: 1, paddingRight: 1, marginRight: 1}} onClick={(d.section || d.url)? (() => onClick(d)) : undefined}/>
          </Badge>
        )
      })}
      </>
    );
  }
  
  const avatar = () => {
    if (props.avatar)
      return (
        <Grid>
          <Text label={isMobile? '' : props.avatar.name} lineHeight={1} color={isWebSignin? props.color : menuColor} bgColor={isWebSignin? menuColor : props.color} icon={props.avatar.imageUrl || 'account_circle'} iconSize='extralarge' sx={{borderRadius: 20, paddingRight: isWebSignin? 2 : 0}} onClick={props.avatar.onClick}/>
        </Grid>
      )
  }
  
  const onClick = async (menu: any) => {
    await props.onClick?.();
    if (menu.section) {
      document.getElementById(menu.section)?.scrollIntoView(true);
      await props.onScrollEnd?.();
    }
    if (menu.url) props.history?.push(menu.url, menu.historyState);
  }

  const onResize = React.useCallback(() => {setIsMobile(AppService.isMobile()); setWidth(document.body.clientWidth)}, []);  
  const onScroll = React.useCallback(() => {setIsOnTop(window.scrollY < 20)}, []);  

  React.useEffect(() => {
    window.addEventListener('resize', onResize);
    window.addEventListener('scroll', onScroll);
    
    return () => {
      window.addEventListener('resize', onResize);
      window.addEventListener('scroll', onScroll);
    }
    
  },[]);
  
  React.useEffect(() => {
    props.onHide?.(isOnTop);
  }, [isOnTop]);
  
  return (
    <>
    
    {isMobile?
    <Transition type='hideOnScroll'>
      <AppBarMui sx={{ bottom: 0, top: 'auto' }}>
        {(props.menu || props.avatar) &&
        <Toolbar sx={{backgroundColor: props.color, justifyContent: 'space-around', padding: 1}}>            
          {menu()}
          {avatar()}
        </Toolbar>}
      </AppBarMui>
    </Transition>

    : //Web view
    <Transition type='hideOnScroll' direction='down'>
      <AppBarMui elevation={isOnTop? 0 : 4} sx={{background: isOnTop? 'transparent' : '', width: props.width, left: props.width && 0, zIndex: 500}}>
        <Toolbar sx={{backgroundColor: isOnTop? '' : props.color, width: props.width || width}}>
          {logo()}
          {menu()}
          {avatar()}
        </Toolbar>
        </AppBarMui>
    </Transition>
    }
    
    {(isMobile || (!props.width && !props.avatar)) &&
    <Toolbar sx={{backgroundColor: props.color || 'primary.light', padding: 1}} > {isMobile && logo()} </Toolbar>
    }
    {props.children}
    </>
  );
}